import { sortBy } from 'lodash-es';
import {
  ApiPatientContactResponseItem,
  ApiUpdatePatientContactsAndConsentRequest,
  ApiUpdatePatientNameRequest,
  ApiUpdatePatientNameResponse,
  ConsentApplicationType,
  ConsentStatus,
  ContactType,
} from 'src/app/core/models';

const patientContacts: ApiPatientContactResponseItem[] = [
  {
    active: true,
    preferenceOrder: 1,
    contactValue: 'me@you.com',
    contactType: 'em',
    contactSubType: 'na',
    consents: [],
  },
  {
    active: false,
    preferenceOrder: 2,
    contactValue: 'inactive@yahoo.com',
    contactType: 'em',
    contactSubType: 'na',
    consents: [],
  },
  {
    active: true,
    preferenceOrder: 1,
    contactValue: '7274221234',
    contactType: 'ph',
    contactSubType: 'm',
    consents: [
      {
        appliesTo: ConsentApplicationType.Marketing,
        consentStatus: ConsentStatus.Granted,
      },
    ],
  },
  {
    active: false,
    preferenceOrder: 2,
    contactValue: '7275551212',
    contactType: 'ph',
    contactSubType: 'm',
    consents: [],
  },
  {
    active: false,
    preferenceOrder: 3,
    contactValue: '7279998888',
    contactType: 'ph',
    contactSubType: 'm',
    consents: [],
  },
];

export const getPatientContacts = (): ApiPatientContactResponseItem[] => patientContacts;

export const updatePatientName = (_: any, body: ApiUpdatePatientNameRequest): ApiUpdatePatientNameResponse[] => {
  return [{ ...body }];
};
export const updatePatientContactsAndConsent = (
  _: any,
  body: ApiUpdatePatientContactsAndConsentRequest
): ApiPatientContactResponseItem[] => {
  const primaryEmailContact = sortBy(
    patientContacts.filter((c) => c.contactType === ContactType.Email && c.active === true),
    'preferenceOrder'
  )[0];

  if (primaryEmailContact) primaryEmailContact.contactValue = body.primaryEmail;

  let primaryPhoneContact = sortBy(
    patientContacts.filter((c) => c.contactType === ContactType.Phone && c.active === true),
    'preferenceOrder'
  )[0];

  if (primaryPhoneContact) {
    primaryPhoneContact.contactValue = body.primaryPhone;
    primaryPhoneContact.contactSubType = body.primaryPhoneSubType;
  } else {
    primaryPhoneContact = {
      active: true,
      preferenceOrder: 1,
      contactValue: body.primaryPhone,
      contactType: 'ph',
      contactSubType: body.primaryPhoneSubType,
      consents: [],
    };

    patientContacts.push(primaryPhoneContact);
  }

  if (body.secondaryPhone) {
    const secondaryPhoneContact = sortBy(
      patientContacts.filter((c) => c.contactType === ContactType.Phone && c.active === true),
      'preferenceOrder'
    )[1];

    if (secondaryPhoneContact) {
      secondaryPhoneContact.contactValue = body.secondaryPhone;
      secondaryPhoneContact.contactSubType = body.secondaryPhoneSubType || 'll';
    } else {
      patientContacts.push({
        active: true,
        preferenceOrder: primaryPhoneContact.preferenceOrder + 1,
        contactValue: body.secondaryPhone,
        contactType: 'ph',
        contactSubType: body.secondaryPhoneSubType || 'll',
        consents: [],
      });
    }
  }

  return patientContacts;
};
